import {Outlet} from "react-router-dom";

const LandingLayout = ({ children }) => {

    return(
        <div>
            <main>
                <Outlet />
            </main>
        </div>
    )

}

export default LandingLayout
